import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { LoadingController} from 'ionic-angular';
import { HttpService } from '../../../../../providers/service/httpservice';
import { APPOINTTLIST } from '../../../../../providers/config/serviceurl';
import { StorageService } from '../../../../../providers/service/storageservice';

@Component({
	selector:'appointinfo',
	templateUrl: 'appointinfo.html'
})
export class AppointInfo{
	itemInfo:any;
	public loading;
	user:any;
  	params:any=[];
  	
	constructor(public global: AppState,private httpService:HttpService,private loadCtrl:LoadingController) {
		this.loadData();
	}
	getInfo(){
		this.user = StorageService.getObj('currentUser');
		this.params = {'hd':this.user.hd};
		this.httpService.post(APPOINTTLIST,this.params).then(anyObj =>this.handleList(anyObj));
		this.itemInfo = StorageService.getObj('rsitemInfo');
	}
	loadData(){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.getInfo();
		this.loading.dismiss();//加载动画结束
	}
	
	handleList(obj:any){
	  	if(obj){
	  		if(this.itemInfo == null){
				this.itemInfo = {"xm":"","jgid":"","przwm":"","zyjszwzg":"","zyjszwjb":"","qdzyjszwrq":"","pzzyjszwjb":"","prqsrq":"","pzzyjsgwdj":"","przyjsgwdjrq":""};
			}
	  		this.itemInfo=obj;
	  		StorageService.setObj("rsitemInfo",this.itemInfo);
	  	}
	 }
	
	//下拉刷新
	doRefresh(refresher){
		setTimeout(() => {
			this.itemInfo = [];
			this.loadData();
			refresher.complete();
		}, 1000);
	}
}



// WEBPACK FOOTER //
// ./src/pages/application/personnel/appoint/appointinfo/appointinfo.ts